/**
 * Layout styled components
 * @module wellRegistrationTotals/styled/layout
 */

import styled from "styled-components/macro";
import {
  Divider as MuiDivider,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";

export const Divider = styled(MuiDivider)(spacing);

export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

export const Card = styled(MuiCard)(spacing);

export const MapContainer = styled.div`
  width: 800px;
  height: 350px;
  margin: 0 auto ${(props) => props.theme.spacing(2)}px;
  border-radius: 4px;
  overflow: hidden;
`;

export const MapScrollContainer = styled.div`
  width: 100%;
  overflow-x: auto;

  @media print {
    overflow-x: visible;
    overflow: visible;
  }
`;
